
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'


export default {
components: {
XAddress
},
data() {
return {
addressSelectModel: [],
addressListModel: ChinaAddressV4Data,
}
},
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-address.vue